import { parseAsString, parseAsStringLiteral, useQueryStates } from "nuqs";

import {
  ORGANIZATION_SEAT_STATUS,
  organizationSeatStatusParams,
} from "~/admins/constants/organizations";

export const organizationSeatFiltersParser = {
  order_by: parseAsString.withDefault("created_at"),
  status: parseAsStringLiteral(organizationSeatStatusParams).withDefault(
    ORGANIZATION_SEAT_STATUS.ACTIVE,
  ),
};

export const useOrganizationSeatFilters = () => {
  return useQueryStates(organizationSeatFiltersParser);
};
